// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Bc5d_","productName":"Table_productName__1WYMk"};